(function () {
  function wrapRevealCharsIn(el) {
    const chars = [];
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (!node.textContent) continue;
      textNodes.push(node);
    }
    textNodes.forEach((textNode) => {
      const text = textNode.textContent;
      const frag = document.createDocumentFragment();
      for (const char of text) {
        if (/\s/.test(char)) {
          frag.appendChild(document.createTextNode(char));
        } else {
          const letter = document.createElement("span");
          letter.className = "sa-mw-section__char";
          /* ASCII/hyphen chars are soft wrap points → "fast-" / "paced". Use NB hyphen. */
          letter.textContent = char === "-" || char === "‐" ? "\u2011" : char;
          frag.appendChild(letter);
          chars.push(letter);
        }
      }
      textNode.parentNode.replaceChild(frag, textNode);
    });
    return chars;
  }

  function groupCharsByVisualLine(chars) {
    if (!chars.length) return [];
    const lines = [];
    let current = [];
    let lastTop = null;
    chars.forEach((el) => {
      const top = Math.round(el.getBoundingClientRect().top);
      if (lastTop !== null && top > lastTop + 2) {
        lines.push(current);
        current = [];
      }
      current.push(el);
      lastTop = top;
    });
    if (current.length) lines.push(current);
    return lines;
  }

  function unwrapVisualLines(block) {
    block.querySelectorAll(".sa-mw-section__copy-line").forEach((line) => {
      const parent = line.parentNode;
      if (!parent) return;
      while (line.firstChild) parent.insertBefore(line.firstChild, line);
      line.remove();
    });
  }

  function wrapVisualLines(block) {
    const chars = [...block.querySelectorAll(".sa-mw-section__char")];
    if (!chars.length) return [];

    unwrapVisualLines(block);
    const lineGroups = groupCharsByVisualLine(chars);
    const ordered = [];

    lineGroups.forEach((lineChars) => {
      const lineEl = document.createElement("span");
      lineEl.className = "sa-mw-section__copy-line";
      const anchor = lineChars[0];
      anchor.parentNode.insertBefore(lineEl, anchor);

      lineChars.forEach((ch) => {
        const prev = ch.previousSibling;
        if (prev && prev.nodeType === Node.TEXT_NODE && prev.parentNode !== lineEl) {
          lineEl.appendChild(prev);
        }
        lineEl.appendChild(ch);
        ordered.push(ch);
      });
    });

    return ordered;
  }

  function getCopyBlocks(copyRoot) {
    const blocks = [...copyRoot.querySelectorAll(":scope > p, :scope > ul, :scope > ol")];
    if (blocks.length) return blocks;
    if (copyRoot.matches("p")) return [copyRoot];
    return [copyRoot];
  }

  function prepareCopyRoot(copyRoot) {
    const blocks = getCopyBlocks(copyRoot);
    const ordered = [];
    blocks.forEach((block) => {
      wrapRevealCharsIn(block);
      ordered.push(...wrapVisualLines(block));
    });
    return ordered;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  const SCROLL_REVEAL_MQ = window.matchMedia("(max-width: 999px)");

  function readScrollRevealMultipliers(track) {
    const h5 = SCROLL_REVEAL_MQ.matches;
    const revealRaw = h5 ? track.dataset.scrollRevealVhH5 : track.dataset.scrollRevealVh;
    const dwellRaw = h5 ? track.dataset.scrollDwellVhH5 : track.dataset.scrollDwellVh;
    const revealMult = Number(revealRaw);
    const dwellMult = Number(dwellRaw);
    return {
      revealMult: Number.isFinite(revealMult) ? revealMult : 100,
      dwellMult: Number.isFinite(dwellMult) ? dwellMult : 50,
    };
  }

  function readPinProgress(track, sticky) {
    const range = track.offsetHeight - sticky.offsetHeight;
    if (range <= 0) return 1;
    const revealRange = Number(track.dataset.revealScrollPx) || range;
    const top = track.getBoundingClientRect().top;
    const scrolled = -top;
    if (scrolled <= 0) return 0;
    if (scrolled >= revealRange) return 1;
    return clamp(scrolled / revealRange, 0, 1);
  }

  function applyCharProgress(chars, progress) {
    const target = Math.min(chars.length, Math.round(progress * chars.length));
    for (let i = 0; i < chars.length; i++) {
      chars[i].classList.toggle("sa-mw-section__char--lit", i < target);
    }
  }

  function initScrollReveal(root, reduceMotion) {
    const track = root.querySelector("[data-sa-mw-scroll-track]");
    const sticky = root.querySelector("[data-sa-mw-scroll-sticky]");
    const section = root.querySelector("[data-sa-mw-scroll-section]");
    const copyRoots = section ? section.querySelectorAll("[data-sa-reveal-root]") : [];
    if (!track || !sticky || !section || !copyRoots.length) return;

    let chars = [];
    const blocks = [];
    copyRoots.forEach((copyRoot) => {
      getCopyBlocks(copyRoot).forEach((b) => blocks.push(b));
      chars = chars.concat(prepareCopyRoot(copyRoot));
    });
    if (!chars.length) return;

    root.classList.add("sa-mw-scroll--ready");

    if (reduceMotion) {
      chars.forEach((el) => el.classList.add("sa-mw-section__char--lit"));
      track.style.removeProperty("height");
      root.classList.add("sa-mw-scroll--reduced");
      return;
    }

    const regroupLines = () => {
      const next = [];
      blocks.forEach((block) => {
        next.push(...wrapVisualLines(block));
      });
      chars = next;
    };

    const layoutTrack = () => {
      const stickyH = sticky.offsetHeight;
      const vh = window.innerHeight || 800;
      const { revealMult: vhMult, dwellMult: dwellVh } = readScrollRevealMultipliers(track);
      const scrollDist = vh * (vhMult / 100);
      const charBonus = Math.min(vh * 0.45, chars.length * 2.5);
      const revealScroll = scrollDist + charBonus;
      const dwellScroll = vh * (dwellVh / 100);
      track.dataset.revealScrollPx = String(Math.round(revealScroll));
      track.style.height = `${Math.round(stickyH + revealScroll + dwellScroll)}px`;
    };

    let ticking = false;
    const update = () => {
      ticking = false;
      applyCharProgress(chars, readPinProgress(track, sticky));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    let resizeTimer = 0;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        regroupLines();
        layoutTrack();
        update();
      }, 120);
    };

    layoutTrack();
    update();

    const onBreakpointChange = () => {
      regroupLines();
      layoutTrack();
      update();
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });
    if (typeof SCROLL_REVEAL_MQ.addEventListener === "function") {
      SCROLL_REVEAL_MQ.addEventListener("change", onBreakpointChange);
    } else if (typeof SCROLL_REVEAL_MQ.addListener === "function") {
      SCROLL_REVEAL_MQ.addListener(onBreakpointChange);
    }

    const ro =
      typeof ResizeObserver === "function"
        ? new ResizeObserver(onResize)
        : null;
    if (ro) ro.observe(sticky);

    root._saMwScrollCleanup = () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      if (typeof SCROLL_REVEAL_MQ.removeEventListener === "function") {
        SCROLL_REVEAL_MQ.removeEventListener("change", onBreakpointChange);
      } else if (typeof SCROLL_REVEAL_MQ.removeListener === "function") {
        SCROLL_REVEAL_MQ.removeListener(onBreakpointChange);
      }
      window.clearTimeout(resizeTimer);
      if (ro) ro.disconnect();
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.saMwScrollInit === "1") return;
    root.dataset.saMwScrollInit = "1";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    initScrollReveal(root, reduceMotion);
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-sa-mw-scroll-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot());
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    boot(event.target);
  });
})();
